// Кампанийные посадки «прямо в игру»: чтение ?scene, события воронки в аналитику,
// install-промпт (A2HS). Игро-специфичны только данные сцен (scenes.ts) и разметка
// оверлеев (index.html); эта логика одинаковая во всех пилотных играх.
//
// window.analytics приходит из инжектируемого /analytics.js (в dev его нет — track
// молча ничего не делает). window.__bip — перехваченный beforeinstallprompt из
// инлайн-сниппета, который build.sh кладёт в <head> собранной игры.

interface BipEvent extends Event {
  prompt: () => void;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
}

declare global {
  interface Window {
    analytics?: { track?: (name: string, params?: Record<string, unknown>) => void };
    __bip?: BipEvent | null;
  }
}

const GAME_ID = 'block-blast';

export const sceneId: string | null = new URLSearchParams(location.search).get('scene');

export function track(name: string, params?: Record<string, unknown>): void {
  try {
    window.analytics?.track?.(name, { scene: sceneId ?? '', game: GAME_ID, ...(params ?? {}) });
  } catch { /* аналитика опциональна */ }
}

function isStandalone(): boolean {
  return !!window.matchMedia?.('(display-mode: standalone)').matches
    || (navigator as unknown as { standalone?: boolean }).standalone === true;
}

export function canInstall(): boolean {
  return !!window.__bip && !isStandalone();
}

export function promptInstall(): void {
  const bip = window.__bip;
  if (!bip) return;
  bip.prompt();
  bip.userChoice
    .then((res) => {
      track(res.outcome === 'accepted' ? 'campaign_install_accepted' : 'campaign_install_dismissed');
    })
    .catch(() => { /* промпт мог быть отменён */ });
  window.__bip = null;
}
